export default __webpack_public_path__ + "static/events_form-e1aba3e2b30442cd9de0d43a83b56a40.png";